var include_header = `
<div id="js-overlay" class="overlay"></div>
<header>
	<div id="js-header" class="header-pc pc-only">
		<div id="js-global_header" class="global-header">
			<div class="global-header__wrap">
				<div class="global-title">
					<div class="global-title__lead">nanaco<br>関連サービス</div>
				</div>
				<ul class="global-list">
					<li class="global-list__item global-list__item--card">
						<a href="https://www.7card.co.jp/" class="global-list__link global-list__link--blank Group_CmnHeader" target="_blank">
							<div class="global-list__inner global-list__inner--card">
								<div class="global-list__title">セブンカード</div>
								<div class="global-list__lead global-list__lead--card">nanacoポイントがたまるクレジットカード</div>
							</div>
						</a>
					</li>
					<li class="global-list__item global-list__item--nanaco">
						<div class="global-list__inner">
							<div class="global-list__title">nanaco</div>
							<div class="global-list__lead global-list__lead--nanaco">nanacoポイントがたまる電子マネー</div>
						</div>
					</li>
					<li class="global-list__item global-list__item--bank">
						<a href="https://www.sevenbank.co.jp/" class="global-list__link global-list__link--blank Group_CmnHeader" target="_blank">
							<div class="global-list__inner global-list__inner--bank">
								<div class="global-list__title">セブン銀行</div>
								<div class="global-list__lead global-list__lead--bank">nanacoポイントがたまる24時間利用できる銀行</div>
							</div>
						</a>
					</li>
				</ul>
			</div>
		</div>
		<div class="header-main">
			<div class="header-main__wrap">
				<div class="header-logo"><a href="/" class="Nanaco_CmnHeader"><img src="/material/img/common/logo/logo_header.png" width="100%" alt="nanaco"></a></div>
				<div class="header-inner">
					<ul class="header-list">
						<li class="header-list__item"><a href="/biz/" class="header-list__link Nanaco_CmnHeader">法人のお客様</a></li>
						<li class="header-list__item"><a href="https://secure.okbiz.jp/7card/?site_domain=nanaco" class="header-list__link Nanaco_CmnHeader">よくあるご質問</a></li>
					</ul>
					<div class="search">
						<form name="search_form" action="https://search-nanaco.dga.jp/" method="GET" onsubmit="return mysearch(this);">
							<input type="hidden" name="ie" value="u">
							<span class="search-form">
								<label><input type="text" name="kw" value="" class="search-box iSearchAssist ui-autocomplete-input" autocomplete="off" role="textbox" aria-autocomplete="list" aria-haspopup="true" placeholder="検索ワードを入力してください"></label>
								<button type="submit" class="search-btn"></button>
							</span>
						</form>
					</div>
					<div class="header-login">
						<a href="https://www.nanaco-net.jp/pc/emServlet" target="_blank" class="Nanaco_CmnHeader Nanaco_LoginButton CvHeader_01"><div class="btn-login">会員メニューログイン</div></a>
					</div>
				</div>
			</div>
			<div class="header-navi">
				<div class="header-navi__wrap">
					<div class="header-navi__logo"><a href="/" class="Nanaco_CmnHeader"><img src="/material/img/common/logo/logo_header.png" width="100%" alt="nanaco"></a></div>
					<ul class="header-navi__list js-header_navi_list">
						<li class="header-navi__item"><a href="/introduction/" id="js-current_introduction" class="header-navi__link Nanaco_CmnHeader">nanacoとは</a></li>
						<li class="header-navi__item"><a href="/entry/" id="js-current_entry" class="header-navi__link Nanaco_CmnHeader">お申し込み方法</a></li>
						<li class="header-navi__item"><a href="/how-to/" id="js-current_how-to" class="header-navi__link Nanaco_CmnHeader">使い方</a></li>
						<li class="header-navi__item"><a href="/alliance/" id="js-current_alliance" class="header-navi__link Nanaco_CmnHeader">使えるお店</a></li>
						<li class="header-navi__item"><a href="/cp/" id="js-current_cp" class="header-navi__link Nanaco_CmnHeader">キャンペーン</a></li>
						<li class="header-navi__item"><a href="/support/" id="js-current_support" class="header-navi__link Nanaco_CmnHeader">お客様サポート</a></li>
					</ul>
				</div>
			</div>
		</div>
	</div>

	<div class="sp-only">
		<div id="js-header_sp" class="header-wrap">
			<div class="header-logo">
				<a href="/" class="Nanaco_CmnHeader"><img src="/material/img/common/logo/logo_nanaco_sp.png" class="header-logo__img" alt="nanaco"></a>
			</div>
			<div class="header-navi">
				<ul class="header-navi__list">
					<li class="header-navi__item header-navi__item--question">
						<a href="https://secure.okbiz.jp/7card/?site_domain=nanaco" class="header-navi__link Nanaco_CmnHeader Nanaco_LoginButton CvHeader_01" target="_blank">
							<img src="/material/img/common/icon/icon_question_mark.png" alt="よくあるご質問">
							<div class="btn-question">よくあるご質問</div>
						</a>
					</li>
					<li class="header-navi__item header-navi__item--login">
						<a href="https://www.nanaco-net.jp/pc/emServlet" class="header-navi__link Nanaco_CmnHeader Nanaco_LoginButton CvHeader_01" target="_blank">
							<img src="/material/img/common/icon/icon_people.png" alt="会員メニューログイン">
							<div class="btn-login">会員メニュー<br>ログイン</div>
						</a>
					</li>
					<li class="header-navi__item header-navi__item--menu js-btn_menu">
						<div class="header-navi__link">
						</div>
					</li>
				</ul>
			</div>
			<div id="js-menu" class="menu">
				<a href="javascript:void(0);" class="menu-link">
					<div class="btn-menu">
						<span class="btn-menu__border"></span>
						<span class="btn-menu__border"></span>
						<span class="btn-menu__border"></span>
					</div>
					<div id="js-menu_lead" class="btn-menu__lead">メニュー</div>
				</a>
			</div>
		</div>
		<div id="js-header_menu" class="header-menu">
			<ul class="header-menu__list header-menu__list--level01">
				<li class="header-menu__list-item">
					<a href="/introduction/" class="header-menu__link-lead Nanaco_CmnMegamenu">nanacoとは</a>
				</li>
				<li class="header-menu__list-item">
					<a href="/entry/" class="header-menu__link-lead Nanaco_CmnMegamenu">お申し込み方法</a>
				</li>
				<li class="header-menu__list-item">
					<a href="/how-to/" class="header-menu__link-lead Nanaco_CmnMegamenu">使い方</a>
				</li>
				<li class="header-menu__list-item">
					<a href="/alliance/" class="header-menu__link-lead Nanaco_CmnMegamenu">使えるお店</a>
				</li>
				<li class="header-menu__list-item">
					<a href="/cp/" class="header-menu__link-lead Nanaco_CmnMegamenu">キャンペーン</a>
				</li>
				<li class="header-menu__list-item">
					<a href="/support/" class="header-menu__link-lead Nanaco_CmnMegamenu">お客様サポート</a>
				</li>
				<li class="header-menu__list-item">
					<a href="/information/" class="header-menu__link-lead Nanaco_CmnMegamenu">お知らせ・ニュースリリース</a>
				</li>
				<li class="header-menu__list-item">
					<a href="/biz/" class="header-menu__link-lead Nanaco_CmnMegamenu">法人のお客様</a>
				</li>
				<li class="header-menu__list-item">
					<div class="header-menu__inner background--type04">
						<a href="https://secure.okbiz.jp/7card/?site_domain=nanaco" class="header-menu__link-lead Nanaco_CmnMegamenu">よくあるご質問</a>
						<div class="search">
							<form name="search_form" action="https://search-nanaco.dga.jp/" method="GET" onsubmit="return mysearch(this);">
								<input type="hidden" name="ie" value="u">
								<span class="search-form">
									<label><input type="text" name="kw" value="" class="search-box iSearchAssist ui-autocomplete-input" autocomplete="off" role="textbox" aria-autocomplete="list" aria-haspopup="true" placeholder="検索ワードを入力してください"></label>
									<button type="submit" class="search-btn"></button>
								</span>
							</form>
						</div>
					</div>
					<li class="header-menu__list-item">
						<div id="js-menu_close" class="header-menu__close">×&nbsp閉じる</div>
					</li>
				</li>
			</ul>
		</div>
	</div>

	<div id="js-groupmenu" class="groupmenu sp-only" style="display: none;">
		<div class="groupmenu-wrap">
			<div class="groupmenu-content">
				<div class="groupmenu-content__amount background--type04">
					<span class="groupmenu-content__amount-lead">nanaco関連サービス</span>
				</div>
				<ul class="groupmenu-content__list">
					<li class="groupmenu-content__item groupmenu-content__item--card">
						<a href="https://www.7card.co.jp/" target="_blank" class="Group_CmnHeader">
							<div class="groupmenu-content__item-title">セブンカード</div>
							<div class="groupmenu-content__item-lead">nanacoポイントがたまるクレジットカード</div>
						</a>
					</li>
					<li class="groupmenu-content__item groupmenu-content__item--bank">
						<a href="https://www.sevenbank.co.jp/" target="_blank" class="Group_CmnHeader">
							<div class="groupmenu-content__item-title">セブン銀行</div>
							<div class="groupmenu-content__item-lead">nanacoポイントがたまる24時間利用できる銀行</div>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</header>
<div id="js-main" class="main">
<div id="js-overlay_wrap">
`;
